import React from "react";
import propTypes from "prop-types";
import { Card, Form, Input, Image, Button, Alert } from "antd";
import {
  UserOutlined,
  LoginOutlined,
  EyeInvisibleFilled,
  EyeFilled,
  LockFilled,
} from "@ant-design/icons";
import logo_text from "../../assets/logo_text.png";
import { POST } from "../../utils/HttpClient";
import { URL_AUTH } from "../../constance/urls";
import { useTranslation } from "react-i18next";
import useLanguage from "../../hooks/useLanguage";
import { useUserContext } from "../../hooks/UserSettingProvider";
import ColorButton from "../common/ColorButton";
import { BLUE_COLOR } from "../../constance/color";
function LoginSegment(props) {
  const [isLoading, setIsLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(false);
  const [toggleShowPassword, setToggleShowPassword] = React.useState(false);
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  const userContext = useUserContext();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setIsLoading(true);
    setErrorMessages(null);
    let url = URL_AUTH.API_TOKEN_AUTH;
    if (props.liff) {
      url = URL_AUTH.LIFF_API_TOKEN_AUTH;
      values = {
        ...values,
        liff_access_token: props.liff.getAccessToken(),
      };
    }

    try {
      const response = await POST(url, values);
      userContext.onLogin(response.data);
      props.onLoggedIn();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setIsLoading(false);
    }
  };
  React.useEffect(() => {
    form.resetFields();
  }, []);

  return (
    <div className="login-form">
      <style>
        {`
          body > div,
          body > div > div,
          body > div > div > div.login-form {
          height: 100%;
          }
        `}
      </style>

      <div style={{ position: "absolute", top: "1rem", right: "1rem" }}>
        <Button.Group>
          <ColorButton
            type={language === "th" ? "primary" : "default"}
            onClick={() => setLanguage("th")}
          >
            TH
          </ColorButton>
          <ColorButton
            type={language === "en" ? "primary" : "default"}
            onClick={() => setLanguage("en")}
          >
            EN
          </ColorButton>
        </Button.Group>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Image
          src={logo_text}
          width={150}
          style={{ display: "block", margin: "0 auto" }}
          preview={false}
        />

        <Card style={{ maxWidth: "350px", width: "90%" }}>
          <Form
            name="login"
            form={form}
            wrapperCol={{ span: 50 }}
            onFinish={onFinish}
          >
            {errorMessages && (
              <Alert
                message={errorMessages}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}
            <Form.Item name="username" rules={[{ required: true }]}>
              <Input
                prefix={<UserOutlined />}
                placeholder={t("user_profiles.username")}
              />
            </Form.Item>
            <Form.Item name="password" rules={[{ required: true }]}>
              <Input
                prefix={<LockFilled />}
                placeholder={t("user_profiles.password")}
                type={toggleShowPassword ? "text" : "password"}
                suffix={
                  <Button
                    icon={
                      toggleShowPassword ? (
                        <EyeFilled />
                      ) : (
                        <EyeInvisibleFilled />
                      )
                    }
                    onClick={() =>
                      setToggleShowPassword((prevState) => !prevState)
                    }
                    size="small"
                    type="text"
                  />
                }
              />
            </Form.Item>
            <Form.Item>
              <Button
                block
                type="primary"
                htmlType="submit"
                loading={isLoading}
                icon={<LoginOutlined />}
                size="large"
              >
                {t("menus.log_in")}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
}

LoginSegment.defaultProps = {
  liff: null,
  onLoggedIn: () => {},
};

LoginSegment.propTypes = {
  liff: propTypes.object,
  onLoggedIn: propTypes.func,
};

export default React.memo(LoginSegment);
